// removed by extract-text-webpack-plugin
module.exports = {"smsCodeInput":"index-smsCodeInput-26M9_","inputWrapper":"index-inputWrapper-sP9Za"};


//////////////////
// WEBPACK FOOTER
// ./src/components/sms-code-input/index.less
// module id = 976
// module chunks = 0